import {

    GET_COUNTRY_STATE_DEFINITIONS_SUCCESS,
    ADD_COUNTRY_STATE_DEFINITION_SUCCESS,
    UPDATE_COUNTRY_STATE_DEFINITION_SUCCESS,
    DELETE_COUNTRY_STATE_DEFINITION_SUCCESS,
    API_ERROR
  } from "./actionTypes"
  
  const INIT_STATE = {
    countryList: [], 
    countryStateList: [], 
    error: {},
  }
  
  const countryStateDefinition = (state = INIT_STATE, action) => {
    switch (action.type) {
  
      case GET_COUNTRY_STATE_DEFINITIONS_SUCCESS:
        return {
          ...state,
          countryStateList: action.payload,
        }
  
      case ADD_COUNTRY_STATE_DEFINITION_SUCCESS:
        return {
          ...state,
          countryStateList: [...state.countryStateList, action.payload],
        }
  
      case UPDATE_COUNTRY_STATE_DEFINITION_SUCCESS:
        return {
          ...state,
          countryStateList: state.countryStateList.map(record =>
            record.guid.toString() === action.payload.guid.toString()
              ? { record, ...action.payload }
              : record
          ),
        }
  
      case DELETE_COUNTRY_STATE_DEFINITION_SUCCESS:
        return {
          ...state,
          countryStateList: state.countryStateList.filter(
            record => record.guid.toString() !== action.payload.toString()
          ),
        }
  
      case API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false 
        }
  
      default:
  
        return state
  
    }
  }
  
  export default countryStateDefinition